import jQuery from 'jquery';
// import { lazyLoadImages } from '../modules/lazyload_Images';
import { gWindowWidth } from '../modules/gWidth';
// import 'slick-carousel';
// import '../modules/slider-item';

const $ = jQuery;
window.jQuery = jQuery;
require('sticky-kit/dist/sticky-kit.js');
// require('default-passive-events');

var Promise = require('es6-promise');
const FontFaceObserver = require('fontfaceobserver');
const Chivo = new FontFaceObserver('Chivo');
const Poppins = new FontFaceObserver('Poppins');
Promise.all([Chivo.load(), Poppins.load()]).then(function () {
    sessionStorage.fontsLoaded = true;
}).catch(function () {
    sessionStorage.fontsLoaded = false;
});

window.bst = {};

// 最初に実行する関数
$(window).on({
    load: function () {
        gWwidth = gWindowWidth();
        if ($('.p-mypage').length) stickLine();
    },
    resize: function () {
        gWwidth = gWindowWidth();
        if ($('.p-mypage').length) stickLine();
    },
    scroll: function () {
        //
    }
});

var gWwidth = gWindowWidth();

jQuery.extend(jQuery.easing, {
    def: 'easeOutQuad',
    easeOutQuart: function (x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeOutExpo: function (e, f, a, h, g) {
        return f === g ? a + h : h * (-Math.pow(2, -10 * f / g) + 1) + a;
    },
    quart: function (x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    }
});

export function initializeMain() {
    const $ = jQuery;
    gWwidth = gWindowWidth();
    if ($('.p-mypage').length) stickLine();

    window.addEventListener('resize', function () {
        gWwidth = gWindowWidth();
        if ($('.p-mypage').length) stickLine();
    });

    window.addEventListener('load', function () {
        gWwidth = gWindowWidth();
        if ($('.p-mypage').length) stickLine();
    });

    // #リンク
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
    });

    $('#nav-sidemenu, #nav-mypage').find('a').click(function () {
        var $btn = $(this).closest('.head-ui-btn');
        var $menu = $btn.attr('id').split('-')[1];
        if (gWwidth > 1023) {
            $btn.addClass('is-hide');
            $btn.siblings('.head-ui-btn').removeClass('is-hide');
        } else {
            $btn.toggleClass('is-open');
            $btn.siblings('.head-ui-btn').removeClass('is-open');
        }
        menuFunc($menu);
    });

    $('.p-mypage__content').click(function (event) {
        event.stopPropagation();
        if (gWwidth < 1025 && $('.mypage-nav').hasClass('is-open')) {
            $('.mypage-nav').removeClass('is-open');
            $('.head-ui-btn').removeClass('is-open');
        }
    });

    /* top - information area
      -------------------------------------------- */
    $('.p-mypage__information').find('dt').find('button').click(function () {
        var $info = $(this).closest('dt');
        $info.toggleClass('is-hide');
        $info.next('dd').slideToggle(500, 'quart');
        return false;
    });

    /* dashboard - tab
  -------------------------------------------- */
    var $dashboardlTab = $('.dashboard__tab');
    var dashboardlTabName = '';

    $dashboardlTab.find('li a').click(function () {
        var $tab = $(this).parent('li');
        if ($tab.hasClass('is-active')) return;
        $tab.siblings('li').removeClass('is-active');
        $tab.toggleClass('is-active');
        dashboardlTabName = $(this).attr('href');

        var $tabBloc = $(dashboardlTabName);
        $tabBloc.removeAttr('style');
        $tabBloc.siblings('.dashboard__list').css({ display: 'none' });
        $tabBloc.css('display', 'none').fadeIn(400);
    });

    /* account - profile area demo
    -------------------------------------------- */
    $('.bloc__act-btn--profile-edit').click(function (e) {
        $(this).addClass('is-hide');
        $('.profile__setting--confirm').css({ display: 'none' });
        $('.profile__setting--edit').css('display', 'none').fadeIn(400);
    });

    $('.c-btn--profedit-submit').find('a, input, button').click(function (e) {
        $('.p-profile-edit__loading').addClass('is-loading');
    });

    $('.c-btn--profedit-cancel').find('a, input, button').click(function (e) {
        profEditClose();
    });

    $('.modal-close').find('a, input, button').click(function () {
        modalClose();
    });

    /* modal mock demo
    -------------------------------------------- */
    $('.c-btn__account--reminder').click(function (e) {
        $('.p-modal-reminder__sender, .p-modal-reminder__finish').removeAttr('style');
        modalShow($('#modal-reminder'));
    });

    $('.c-btn__account--delete').click(function (e) {
        modalShow($('#modal-delete'));
    });

    $('.c-btn--modal-reminder').find('a, input, button').click(function (e) {
        $(this).closest('.p-modal-reminder__sender').css({ display: 'none' });
        $('.p-modal-reminder__finish').fadeIn(400);
    });

    /* shipping - card demo
    -------------------------------------------- */
    $('.c-shipping-card__front').click(function (e) {
        var $card = $(this).closest('.c-shipping-card');
        $card.addClass('is-flip');
        $card.siblings('.c-shipping-card').removeClass('is-flip');
    });

    $('.shipping__act-btn--back').click(function (e) {
        $('.c-shipping-card').removeClass('is-flip');
    });

    $('.shipping__act-btn--select').click(function (e) {
        var $card = $(this).closest('.c-shipping-card');
        $card.removeClass('is-flip').addClass('is-active');
        $card.siblings('.c-shipping-card').removeClass('is-flip is-active');
    });

    $('.shipping__act-btn--delete').click(function (e) {
        var $cardAction = $(this).closest('.c-shipping-card__setting');
        $(this).closest('.c-shipping__action').css({ display: 'none' });
        $cardAction.find('.c-shipping__confirm').fadeIn(400);
    });

    $('.shipping__conf-btn--cancel').click(function (e) {
        var $cardAction = $(this).closest('.c-shipping-card__setting');
        $(this).closest('.c-shipping__confirm').css({ display: 'none' });
        $cardAction.find('.c-shipping__action').fadeIn(400);
    });

    $('.shipping__conf-btn--delete').click(function (e) {
        var $card = $(this).closest('.c-shipping-card');

        $card.addClass('is-remove').on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
            if ($card.hasClass('is-active')) $card.next('.c-shipping-card').addClass('is-active');
            $card.remove();
            $(this).off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd');
        });
    });


    // mailaddress
    $('.c-btn__account--mailaddress').click(function (e) {
        $('.p-modal-mailaddress__sender, .p-modal-mailaddress__authcode, .p-modal-mailaddress__finish').removeAttr('style');
        $('.authcode-char').val('');
        modalShow($('#modal-mailaddress'));
    });

    // $('.c-btn--modal-mailaddress').find('a, input, button').click(function (e) {
    //     $(this).closest('.p-modal-mailaddress__sender').css({ display: 'none' });
    //     $('.p-modal-mailaddress__authcode').fadeIn(400);
    // });

    $('.c-btn--modal-mailaddress-back').find('a, input, button').click(function (e) {
        $(this).closest('.p-modal-mailaddress__authcode').css({ display: 'none' });
        $('.p-modal-mailaddress__sender').fadeIn(400);
    });

    $('.c-btn--modal-mailaddress-again').find('a, input, button').click(function (e) {
        $(this).parent('.c-btn').addClass('is-send');

        setTimeout(function () {
            $('.c-btn--modal-mailaddress-again').removeClass('is-send');
        }, 3000);
    });

    // $('.authcode-char').on('change blur', function () {
    //     let flag = true;
    //     $('.authcode-char').each(function (e) {
    //         if ($('.authcode-char').eq(e).val() === '') {
    //             flag = false;
    //         }
    //     });
    //
    //     if (flag) {
    //         authcodeCheck();
    //     }
    // });
    //
    // function authcodeCheck () {
    //     $('.p-authcode-check__loading').addClass('is-loading');
    //
    //     setTimeout(function () {
    //         $('.p-authcode-check__loading').removeClass('is-loading');
    //         $('.p-modal-mailaddress__authcode').css({ display: 'none' });
    //         $('.p-modal-mailaddress__finish').fadeIn(400);
    //     }, 1500);
    // }

    // authcode - Auto focus next
    $('.authcode-char').on('input', this, function (e) {
        const nextElement = this.nextElementSibling;
        if (/^[a-zA-Z0-9\-_]+$/.test(this.value) || this.value === '') {
            if (e.target.type === 'text' && nextElement && nextElement.classList.contains('authcode-char')) {
                nextElement.focus();
            }
        } else {
            this.value = '';
        }
    });

    // authcode - Paste to input
    document.querySelectorAll('.authcode-char').forEach((input, idx, array) => {
        input.addEventListener('paste', function (e) {
            const clipboardData = e.clipboardData || window.clipboardData;
            let pastedData = clipboardData.getData('Text');
            e.preventDefault();

            for (let i = 0; i < 6 && i < pastedData.length; i++) {
                array[idx + i].value = pastedData[i];
            }
        });
    });


    /* payment - card demo
    -------------------------------------------- */
    $('.c-payment-card__front').click(function (e) {
        var $card = $(this).closest('.c-payment-card');
        $card.addClass('is-flip');
        $card.siblings('.c-payment-card').removeClass('is-flip');
    });

    $('.payment__act-btn--back').click(function (e) {
        $('.c-payment-card').removeClass('is-flip');
    });

    $('.payment__act-btn--select').click(function (e) {
        var $card = $(this).closest('.c-payment-card');
        $card.removeClass('is-flip').addClass('is-active');
        $card.siblings('.c-payment-card').removeClass('is-flip is-active');
    });

    $('.payment__act-btn--delete').click(function (e) {
        var $cardAction = $(this).closest('.c-payment-card__setting');
        $(this).closest('.c-payment__action').css({ display: 'none' });
        $cardAction.find('.c-payment__confirm').fadeIn(400);
    });

    $('.payment__conf-btn--cancel').click(function (e) {
        var $cardAction = $(this).closest('.c-payment-card__setting');
        $(this).closest('.c-payment__confirm').css({ display: 'none' });
        $cardAction.find('.c-payment__action').fadeIn(400);
    });

    $('.payment__conf-btn--delete').click(function (e) {
        var $card = $(this).closest('.c-payment-card');

        $card.addClass('is-remove').on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
            if ($card.hasClass('is-active')) $card.next('.c-payment-card').addClass('is-active');
            $card.remove();
            $(this).off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd');
        });
    });

    /* shipping - edit demo
      -------------------------------------------- */
    $('.bloc__act-btn--add-shipping, .shipping__act-btn--edit, .card__add-btn--shipping').click(function (e) {
        var cType = $(this).attr('class');
        if (cType.match(/edit/)) {
            $('.p-mypage__shipping--edit').find('.mypage-bloc__head h2');
        } else {
            $('.p-mypage__shipping--edit').find('.mypage-bloc__head h2');
        }
        $('.c-shipping-card').removeClass('is-flip');
        $(this).closest('.p-mypage__shipping--list').css({ display: 'none' });
        $('.p-mypage__shipping--edit').fadeIn(400);
        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    // $('.c-btn--shptedit-submit').find('a, input, button').click(function (e) {
    //     $('.p-shptedit-edit__loading').addClass('is-loading');
    //
    //     setTimeout(function () {
    //         shptEditClose();
    //     }, 1500);
    // });

    $('.c-btn--shptedit-cancel').find('a, input, button').click(function (e) {
        shptEditClose();
    });

    function shptEditClose() {
        $('.c-shipping-card').removeClass('is-flip');
        $('.p-mypage__shipping--list').css('display', 'none').fadeIn(400);
        $('.p-mypage__shipping--edit').removeAttr('style');
        $('.p-shptedit-edit__loading').removeClass('is-loading');
        $('html, body').animate({ scrollTop: 0 }, 300);
    }

    /* payment - edit demo
      -------------------------------------------- */
    $('.bloc__act-btn--add-payment, .payment__act-btn--edit, .card__add-btn--payment').click(function (e) {
        var cType = $(this).attr('class');
        if (cType.match(/edit/)) {
            $('.p-mypage__payment--edit').find('.mypage-bloc__head h2').text('支払方法の確認・変更');
        } else {
            $('.p-mypage__payment--edit').find('.mypage-bloc__head h2').text('支払方法の追加');
        }
        $(this).closest('.p-mypage__payment--list').css({ display: 'none' });
        $('.p-mypage__payment--edit').fadeIn(400);
        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    // This code is troubling api error handling.
    // $('.c-btn--cardedit-submit').find('a, input, button').click(function (e) {
    //     $('.p-cardedit-edit__loading').addClass('is-loading');
    //
    //     setTimeout(function () {
    //         cardEditClose();
    //     }, 1500);
    // });

    $('.c-btn--cardedit-cancel').find('a, input, button').click(function (e) {
        cardEditClose();
    });


    function menuFunc(elm) {
        var $menu = $(`.p-nav__${elm}`);
        if (gWwidth > 1023) {
            $menu.removeClass('is-hide');
            $menu.siblings('.mypage-nav').addClass('is-hide');
        } else {
            $menu.toggleClass('is-open');
            $menu.siblings('.mypage-nav').removeClass('is-open');
        }
    }

    /* --------------------------------------------
        modal
    -------------------------------------------- */
    var $modalElm = $('.l-modal');
    var isPopup = $modalElm.hasClass('is-visible');

    $modalElm.click(function (event) {
        event.stopPropagation();
        if ($(event.target).is('.l-modal__inner')) {
            modalClose();
        }
    });

    function modalShow($elm) {
        if (!isPopup) {
            $elm.addClass('is-visible');
            isPopup = true;
        }
    };

    function modalClose() {
        if (isPopup) {
            $modalElm.removeClass('is-visible').on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                $(this).off('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd');
            });
            isPopup = false;
        }
    }

    function cardEditClose() {
        $('.p-mypage__payment--list').css('display', 'none').fadeIn(400);
        $('.p-mypage__payment--edit').removeAttr('style');
        $('.p-cardedit-edit__loading').removeClass('is-loading');
        $('html, body').animate({ scrollTop: 0 }, 300);

        // point step2
        $('.point-charge__payment').css('display', 'none').fadeIn(400);
        $('.point-charge__payment-edit').removeAttr('style');
    }

    $('.c-btn__cvc-open').click(function (e) {
        $('.payment__cvc').fadeIn('fast');
    });

    $('.c-btn__cvc-close').click(function (e) {
        $('.payment__cvc').fadeOut('fast');
    });

    /* payment (point step2) - edit demo-------------------------------------------- */
    $('.c-payment-card--point .payment__act-btn--edit, .c-payment-add--point .card__add-btn--payment').click(function (e) {
        $(this).closest('.point-charge__payment').css({ display: 'none' });
        $('.point-charge__payment-edit').fadeIn(400);
        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    /* creditcard - input demo
    -------------------------------------------- */
    const creditcardCheckerjs = require('creditcard-checkerjs');

    $('#input__creditcard-number').on({
        keyup: function () {
            cardBrand(this.value);
        },
        input: function (e) {
            cardNumSpace(e);
        }
    });

    var cardNumRegExp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
    var cardNumMaxLength = 19;

    function cardBrand(number) {
        const $brand = $('.c-creditcard').find('.cred-brand');

        switch (creditcardCheckerjs.cardtype(number)) {
        case creditcardCheckerjs.type.VISA:
            $brand.find('.visa').addClass('is-show');
            break;
        case creditcardCheckerjs.type.MASTER:
            $brand.find('.master').addClass('is-show');
            break;
        case creditcardCheckerjs.type.JCB:
            $brand.find('.jcb').addClass('is-show');
            break;
        case creditcardCheckerjs.type.AMEX:
            $brand.find('.amex').addClass('is-show');
            cardNumRegExp = /^(\d{1,4})?(\d{1,6})?(\d{1,5})?$/;
            cardNumMaxLength = 17;
            break;
        case creditcardCheckerjs.type.DINERS:
            $brand.find('.diners').addClass('is-show');
            cardNumRegExp = /^(\d{1,4})?(\d{1,6})?(\d{1,4})?$/;
            cardNumMaxLength = 16;
            break;
        case creditcardCheckerjs.type.UNKNOWN:
        default:
            $brand.find('li').removeClass('is-show');
            cardNumRegExp = /^(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,4})?$/;
            cardNumMaxLength = 19;
            break;
        }
    }

    function cardNumSpace(e) {
        if (e.target.value.length > cardNumMaxLength) {
            e.target.value = e.target.value.slice(0, cardNumMaxLength);
        }
        const digits = e.target.value.replace(/[^0-9]/g, '');
        e.target.value = [...cardNumRegExp.exec(digits)].slice(1).filter(e => e).join(' ');
    }

    // expiration auto slash
    $('#input__creditcard-expiration').on('input', function (e) {
        if (!/^\d{0,2}\/?\d{0,2}$/.test($(this).val())) {
            $(this).val('');
            return;
        }
        if (/^\d{3,}$/.test($(this).val())) {
            $(this).val($(this).val().match(new RegExp('.{1,2}', 'g')).join('/'));
        }
    });

    /* contact - select-box demo -------------------------------------------- */
    $('.p-contact__form').find('select[name=inquiry_category]').on('change', function () {
        if ($(this).find('option:selected').text() === '決済データに関して') {
            $('.p-contact__form').find('dl.option').addClass('is-show');
            $('.p-contact__form').find('dl.option').slideDown(300, 'swing');
        } else {
            $('.p-contact__form').find('dl.option').removeClass('is-show');
            $('.p-contact__form').find('dl.option').slideUp(300, 'swing');
        }
    });
}

/* sticky
    ----------------------------------------------- */
var isStick = false;
var $stickElm;

function stickLine() {
    $stickElm = $('.mypage-nav__inner');

    if (gWwidth > 1024) {
        if (!isStick) {
            $stickElm.stick_in_parent({ parent: '.p-mypage', offset_top: 110 }).on('sticky_kit:recalc');
            isStick = true;
        }
    } else {
        isStick = false;
        $stickElm.trigger('sticky_kit:detach');
    }
};

export function profEditClose() {
    $('.bloc__act-btn--profile-edit').removeClass('is-hide');
    $('.profile__setting--confirm').css('display', 'none').fadeIn(400);
    $('.profile__setting--edit').removeAttr('style');
    $('.p-profile-edit__loading').removeClass('is-loading');
}

export function stopLoading() {
    setTimeout(function () {
        $('.p-profile-edit__loading').removeClass('is-loading');
    }, 1000);
}
